// permiso.guard.ts
import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { map, Observable, of, tap } from 'rxjs';
import { UserService } from '@core/services/user.service';

export const permisoCanMatch: CanMatchFn = (route): Observable<boolean | UrlTree> => {
    const user = inject(UserService);
    const router = inject(Router);
    const accion = route.data?.['accion'] as string;
    
    if (!accion) {
        
        return of(false);
    }
    return user.tieneAcceso(accion).pipe(
        tap(),
        map(ok => ok || router.createUrlTree(['']))
    );
};
